import { hashOptionMap } from "../constants/hashOptions";

export const parseHashOptions = (text: string) => {
  for (const [key, value] of Object.entries(hashOptionMap)) {
    text = text.replace(new RegExp(`${key}`, "g"), value);
  }

  return text;
};
